module.exports = __webpack_public_path__ + "assets/eabfb2f527b905f12e004263d1a802c9.json";